import * as Sentry from "@sentry/react";

// No-op when REACT_APP_SENTRY_DSN is unset. Safe to ship without configuring.
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN || undefined,
  environment: process.env.REACT_APP_ENV || "production",
});
